module.exports = __webpack_public_path__ + "img/ZWF_Lucas_Thayna.cfd41783.jpg";